import UiMessage from "../../components/message/Message.component";
import { useBiometrics } from "../../hooks/useBiometrics";
import { MessageSeverity, UiMessageProps } from "../../models/components/field-message.model";
import { BiometricType } from "../../models/entities/biometrics.model";

const TrackHealthState = (query: ReturnType<typeof useBiometrics>) => {
	const getMessage = () => {
		let result: UiMessageProps = {
			severity: MessageSeverity.LOADING,
			label: "UI_COMPONENTS.MESSAGE.MSG.LOADING",
		};
		if (query.isError) {
			result = {
				severity: MessageSeverity.DANGER,
				label: "UI_COMPONENTS.MESSAGE.MSG.ERROR",
			};
		} else if (
			!query.isLoading &&
			!query.isError &&
			!query.data.get(BiometricType.glucose) &&
			!query.data.get(BiometricType.blood_pressure) &&
			!query.data.get(BiometricType.weight)
		) {
			result = {
				severity: MessageSeverity.INFO,
				label: "TRACK_HEALTH.EMPTY",
			};
		}
		return result;
	};

	return (
		<div className="track-health__state">
			<UiMessage
				label={getMessage().label}
				severity={getMessage().severity}
			/>
		</div>
	);
};
export default TrackHealthState;
